// extracted by mini-css-extract-plugin
export default {"f":"bafacd2cd0","main":"a0a80fa483","btn":"e7b4096751","w":"_98319b8911","h":"e9d7bc7c58","lh25":"_6d6e5270f4","wb":"_2bbc3effeb","b":"_5c1a1b802a","bx":"d9762df157"};